import React from 'react';
import {
  Box, Typography, Button, Stack, Container,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { UserStatus } from '@marageti/z4-sdk/lib/auth';
import {
  ErrorBox,
  ErrorMessage,
  ErrorTitle,
  Icons,
  ContextMenu,
  ContextMenuButton,
  ContextMenuItem,
  ZAvatar,
} from '@marageti/z4-lib';
import ProfileEditor from '../edit';
import styles from './styles';
import { ViewProps } from './types';
import ProfileCard from './user-profile-info';
import { peopleStatusIcons } from '../../../../components/status-icons';

const UserProfileView = ({
  buttonId,
  contextMenuAnchor,
  contextMenuOpen,
  error,
  menuId,
  onClickNewStatus,
  onEditAvatar,
  teamMember,
  user,
  setContextMenuAnchor,
  status,
  contextMenuProps,
  editorOpen,
  onCloseEditor,
  isAdmin,
}: ViewProps) => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md">
      <Box
        sx={styles.profileWrapper}
      >
        {error ? (
          <ErrorBox>
            <ErrorTitle>
              There was an error getting this user
            </ErrorTitle>
            <ErrorMessage>
              {`Code: ${error.code}: ${error.message}`}
            </ErrorMessage>
          </ErrorBox>
        ) : (
          <Box>
            <Box
              sx={{
                display: 'flex',
                paddingBottom: {
                  mobile: '32px',
                  desktop: '24px',
                },
                alignItems: 'center',
                width: {
                  desktop: '686px',
                  mobile: '100%',
                },
              }}
            >
              <Button
                aria-label="back to list of users"
                onClick={() => navigate(-1)}
                sx={{ padding: '0px 16px 0px 0px', minWidth: '0px' }}
              >
                <Icons.ArrowLeft sx={{ padding: '0px', margin: '0px' }} />
              </Button>
              <Typography
                variant="h3"
                sx={{
                  color: 'primary.main',
                  paddingRight: '15px',
                }}
              >
                {teamMember?.fullName}
              </Typography>
              {status && (
              <ContextMenuButton
                id={buttonId}
                onClick={(e) => setContextMenuAnchor(e.currentTarget)}
                open={contextMenuOpen}
                menuId={menuId}
              >
                {peopleStatusIcons[status].icon}
              </ContextMenuButton>
              )}
              <ContextMenu
                anchorEl={contextMenuAnchor}
                buttonId={buttonId}
                id={menuId}
                onClose={() => setContextMenuAnchor(null)}
                open={contextMenuOpen}
              >
                <ContextMenuItem onClick={() => onClickNewStatus(UserStatus.ENABLED)}>
                  <Stack spacing={1.5} direction="row">
                    {peopleStatusIcons.ENABLED.icon}
                    <Typography variant="h4">
                      Enabled
                    </Typography>
                  </Stack>
                </ContextMenuItem>
                <ContextMenuItem onClick={() => onClickNewStatus(UserStatus.DISABLED)}>
                  <Stack spacing={1.5} direction="row">
                    {peopleStatusIcons.DISABLED.icon}
                    <Typography variant="h4">
                      Disabled
                    </Typography>
                  </Stack>
                </ContextMenuItem>
              </ContextMenu>
            </Box>
            <Box sx={styles.avatarBoxMobile}>
              <ZAvatar
                name={teamMember?.fullName}
                size={128}
                loading={!teamMember}
                onEdit={onEditAvatar}
                src={teamMember?.avatar}
              />
            </Box>
            <ProfileCard
              teamMember={teamMember}
              user={user}
              contextMenuProps={contextMenuProps}
              isAdmin={isAdmin}
              onEditAvatar={onEditAvatar}
            />
            <ProfileEditor open={editorOpen} onClose={onCloseEditor} />
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default UserProfileView;
